// A page being opened syncs its own part from Sertica (SPEC §6.3), when the server finds it older
// than 5 min: the same part its Sync button reads. Run once per page (Dashboard); the Sync buttons,
// in both the desktop and the mobile bar, show its state from here.
import { useEffect, useSyncExternalStore } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { syncScopeOf, type Tab } from "@po/shared";
import { useViewSync, type ViewSyncState } from "./view-sync";

let current: ViewSyncState = { status: "idle" };
const listeners = new Set<() => void>();
const publish = (s: ViewSyncState) => {
  current = s;
  listeners.forEach((l) => l());
};

/** Syncs the open page's part when it is opened. Items are read as searched and browsed instead. */
export function usePageSync(tab: Tab | undefined) {
  const qc = useQueryClient();
  const scope = tab ? syncScopeOf(tab) : null;
  const state = useViewSync(scope && scope !== "all" && scope !== "full" && scope !== "items" ? { kind: "tab", scope } : null, () => void qc.invalidateQueries());
  useEffect(() => publish(state), [state]);
}

export function usePageSyncState(): ViewSyncState {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
